export class SurCaseProcAssignmentModel {
  SurCaseProcAsgnId: number;
  SurCaseId: number;
  ProcedureCode: string;
  ProceduresDescription: string;
  ProceduresRachsValue: number;
  Updatedby: string;
}
